/**
 * systemTooltips.js — Centralised explanations for game systems.
 *
 * Used by <TooltipBadge id="..."/> to surface short, friendly descriptions
 * of mechanics that aren't obvious from the surrounding UI label.
 *
 * Keep each entry to ~2-4 short lines. Players hover for a refresher,
 * not a wiki article — link to the Progression Guide for deep dives.
 */

const TOOLTIPS = {
  'market.commission': {
    title: 'Market Commission',
    body:
      'The Market charges a 2% commission on every completed sale.\n' +
      'You receive 98% of the sale price; the rest is sunk to keep gold inflation in check.',
  },
  'shop.cha-discount': {
    title: 'Charisma Discount',
    body:
      'High Charisma reduces shop buy prices and increases sell prices.\n' +
      'The percentage shown applies to everything in this shop. Your sell-side bonus may differ slightly.',
  },
  'xp.rested': {
    title: 'Rested XP',
    body:
      'Time logged out earns rested XP (capped at 100%).\n' +
      'While the bar is filled, monster kills grant double XP until the bonus pool is drained.',
  },
  'world.tier': {
    title: 'World Tier',
    body:
      'Voluntary difficulty toggle that scales monster level and reward multipliers.\n' +
      'Higher tiers grant more gold, XP, and rare drops. Lower or raise it freely from the World Tier menu.',
  },
  'patron.perks': {
    title: 'Patron Perks',
    body:
      'Patron grants +50% XP & gold, 2 free daily Delves, 200 bonus Crowns/month, ' +
      'a 10% Crown Shop discount, the ★ chat badge, and an exclusive title.',
  },
};

export function getSystemTooltip(id) {
  return TOOLTIPS[id] || null;
}

export default TOOLTIPS;
